/**
 * Canonical navigation items for the app sidebar. Order and visibility are
 * per-user preferences (see preferences.tsx); this is the master list and the
 * default order.
 */
import { messagesFor } from '@/i18n/messages'
import { navMessages } from '@/i18n/text/shell'

export interface NavItemDef {
  id: string
  to: string
  /** Only shown to admin / superadmin. */
  adminOnly?: boolean
  /** Only shown to superadmin (Laufið). Implies adminOnly. */
  superAdminOnly?: boolean
  /** Hidden until the matching server feature flag is on (GET /api/auth/methods). */
  featureFlag?: 'accessRequests' | 'mailpit'
}

export const NAV_ITEMS: NavItemDef[] = [
  { id: 'dashboard', to: '/', adminOnly: true },
  { id: 'customers', to: '/customers' },
  { id: 'users', to: '/admin/users', adminOnly: true },
  { id: 'access-requests', to: '/admin/umsoknir', adminOnly: true, featureFlag: 'accessRequests' },
  { id: 'companies', to: '/admin/companies', adminOnly: true, superAdminOnly: true },
  { id: 'adminSettings', to: '/admin/settings', adminOnly: true, superAdminOnly: true },
  { id: 'mailpit', to: '/admin/mailpit', adminOnly: true, superAdminOnly: true, featureFlag: 'mailpit' },
  { id: 'activity', to: '/admin/activity', adminOnly: true },
  { id: 'zeroCollections', to: '/admin/null-losanir', adminOnly: true, superAdminOnly: true },
  { id: 'unknownMaterials', to: '/admin/othekkt-efni', adminOnly: true, superAdminOnly: true },
  { id: 'verkefni', to: '/verkefni', adminOnly: true },
  { id: 'settings', to: '/settings' },
]

export const NAV_BY_ID: Record<string, NavItemDef> = Object.fromEntries(
  NAV_ITEMS.map((i) => [i.id, i])
)

export const DEFAULT_NAV_ORDER = NAV_ITEMS.map((i) => i.id)

export function navLabel(id: string): string {
  const labels = messagesFor(navMessages) as Record<string, string>
  return labels[id] ?? id
}
